<script>
    export let currentRoute;
    export let params;

</script>

<h1>Welcome</h1>